// (2026-09-28, bug-batch#1 P2) Centralized Spanish role-label map.
// Backend role keys (Spanish canonical per config/navigation.ts convention) map
// to the Spanish display labels used everywhere a role renders in the UI
// (sidebar profile block, dashboard 'Rol:' headers, admin tables). English
// aliases ('resident', 'superadmin', 'provider') are tolerated because legacy
// data and some seed rows still carry them. Unknown roles fall back to a
// humanized version of the raw key.
const ROLE_LABELS: Record<string, string> = {
  super_admin: 'Super Administrador',
  superadmin: 'Super Administrador',
  admin: 'Administrador',
  sub_admin: 'Subadministrador',
  directive: 'Directivo',
  directivo: 'Directivo',
  propietario: 'Propietario',
  residente: 'Residente',
  resident: 'Residente',
  empleado: 'Empleado',
  security: 'Seguridad',
  seguridad: 'Seguridad',
  maintenance_staff: 'Mantenimiento',
  familiar: 'Familiar',
  visitante: 'Visitante',
  provider: 'Proveedor',
  proveedor: 'Proveedor',
};

export function getRoleLabel(role: string | null | undefined): string {
  if (!role) return '';
  return ROLE_LABELS[role] || role.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export default ROLE_LABELS;
